import { render, staticRenderFns } from "./Ckplayer.vue?vue&type=template&id=220d9724&scoped=true"
import script from "./Ckplayer.vue?vue&type=script&lang=js"
export * from "./Ckplayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d9724",
  null
  
)

export default component.exports